import { parseFillGradient, parseFillMode, parseObjectGlow, parseObjectShadow, } from './objectVisualStyle';
import { parseStrokeSides } from './strokeSides';
export function parseShapeBody(body) {
    if (!body)
        return {};
    try {
        const parsed = JSON.parse(body) ?? {};
        if (parsed.strokeSides) {
            parsed.strokeSides = parseStrokeSides(parsed.strokeSides);
        }
        parsed.fillMode = parseFillMode(parsed.fillMode) ?? parsed.fillMode;
        parsed.fillGradient = parseFillGradient(parsed.fillGradient) ?? parsed.fillGradient;
        parsed.shadow = parseObjectShadow(parsed.shadow) ?? parsed.shadow;
        parsed.glow = parseObjectGlow(parsed.glow) ?? parsed.glow;
        return parsed;
    }
    catch {
        return {};
    }
}
const SHAPE_STYLE_KEYS = [
    'shapeType',
    'pathData',
    'fill',
    'fillMode',
    'fillGradient',
    'stroke',
    'strokeWidth',
    'strokeStyle',
    'strokeSides',
    'shadow',
    'glow',
];
export function shapeBodyFromSceneObject(obj) {
    const data = {
        shapeType: obj.shapeType ?? 'rectangle',
    };
    if (obj.pathData)
        data.pathData = obj.pathData;
    if (obj.fill != null)
        data.fill = obj.fill;
    if (obj.fillMode != null)
        data.fillMode = obj.fillMode;
    if (obj.fillGradient != null)
        data.fillGradient = obj.fillGradient;
    if (obj.stroke != null)
        data.stroke = obj.stroke;
    if (obj.strokeWidth != null)
        data.strokeWidth = obj.strokeWidth;
    if (obj.strokeStyle != null)
        data.strokeStyle = obj.strokeStyle;
    if (obj.strokeSides != null)
        data.strokeSides = obj.strokeSides;
    if (obj.shadow != null)
        data.shadow = obj.shadow;
    if (obj.glow != null)
        data.glow = obj.glow;
    return data;
}
export function serializeShapeBody(data) {
    return JSON.stringify(shapeBodyFromSceneObject({
        shapeType: data.shapeType,
        pathData: data.pathData,
        fill: data.fill,
        fillMode: data.fillMode,
        fillGradient: data.fillGradient,
        stroke: data.stroke,
        strokeWidth: data.strokeWidth,
        strokeStyle: data.strokeStyle,
        strokeSides: data.strokeSides,
        shadow: data.shadow,
        glow: data.glow,
    }));
}
export function resolveShapeFieldsFromBody(type, body) {
    if (type !== 'shape')
        return {};
    const parsed = parseShapeBody(body);
    const shapeType = parsed.shapeType ?? (parsed.pathData ? 'path' : 'rectangle');
    return {
        shapeType,
        pathData: parsed.pathData,
        fill: parsed.fill,
        fillMode: parsed.fillMode,
        fillGradient: parsed.fillGradient,
        stroke: parsed.stroke,
        strokeWidth: parsed.strokeWidth,
        strokeStyle: parsed.strokeStyle,
        strokeSides: parsed.strokeSides,
        shadow: parsed.shadow,
        glow: parsed.glow,
    };
}
